import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { SKIP_LOADER } from 'src/app/utils/constants';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
	constructor(private readonly loaderService: LoaderService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const isButtonLoader = req.context.get(SKIP_LOADER);

		if (isButtonLoader) this.loaderService.showInButton();
		else this.loaderService.show();

		return next
			.handle(req)
			.pipe(
				finalize(() => (isButtonLoader ? this.loaderService.hideInButton() : this.loaderService.hide()))
			);
	}
}
